// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonWrapper } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import { filterListStyles } from "@sc/Overrides/Widgets/ProductList/ProductListFilterList";
import Close from "@sc/XDL/Icons/Close";
import { createLinkIconStyles, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

filterListStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        &:not(:empty) {
            margin-top: 8px;
        }
    `,
};
filterListStyles.titleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 6px;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

filterListStyles.filterText = {
    variant: "h5",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};

filterListStyles.clearAllLink = {
    ...createLinkIconStyles(Close, {
        icon: {
            iconProps: {
                size: 7,
            },
        },
    }),
};

filterListStyles.clearButton = {
    variant: "secondary",
};

filterListStyles.applyButton = {};

filterListStyles.clearFilterButtonWrapper = {
    css: css`
        position: absolute;
        padding: 19px 16px;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: ${getColor("common.white")};
        ${ButtonWrapper} {
            width: 100%;
        }
    `,
};

filterListStyles.filterTag = {
    mergeCss: true,
    css: css`
        margin: 0;
    `,
};
